import posthog from 'posthog-js';
import { browser } from '$app/environment';

import { error } from '@sveltejs/kit';
import { subscribeToPrizes } from '$stores/prizes';


export const load = async ({ fetch }) => {
	if (browser) {
		try {
			posthog.init('phc_hvVswqvYBd9sS0Ol1PIANwMlZbkrna10eVktQnvQqLf', {
				api_host: 'https://eu.posthog.com',
				autocapture: false,
				person_profiles: 'always',
			});

			
			// posthog.onFeatureFlags(function() {
			//   // feature flags should be available at this point
			//     if (posthog.getFeatureFlag('prize-page-sort-by')  == 'date') {
			//         setCookie('prize-page-sort-by', 'date');
			//     }
			//     if (posthog.getFeatureFlag('prize-page-sort-by')  == 'tickets') {
			//         setCookie('prize-page-sort-by', 'tickets');
			//     }
			// })
			//

			// const res = await fetch(
			// 	`https://us-central1-staging-ac5f0.cloudfunctions.net/getInitialProducts`
			// );
			// const items = await res.json();

			// if (!res.ok) {
			// 	// console.log({ items });/
			// 	throw error(500, "Couldn't fetch products");
			// }

			// if (items) {
			// 	productStore.set(items);
			// } else {
			// 	const prizeStore = await prizes;
			// 	prizeStore.subscribe(async (val) => {
			// 		if (!val) return;
			// 		productStore.set(val);
			// 	});
			// }
			// return { items };
		} catch (e) {
			console.error('Error calling layout.js:', e);
			// throw error(500, 'Failed to fetch products');
		}
	}

	const unsubscribe = subscribeToPrizes();
	// Make sure to return unsubscribe for cleanup when leaving the app
	return {
		onDestroy: unsubscribe
	};
};
